import { ADMINISTRATORS, AGENTS, ANALYSTS, KNOWLEDGEAGENT, KNOWLEDGEREADER, SETTINGS_PAGES } from '../shared/utils/constants';

/**
 * Which settings pages a user may open, #31467. Agents could reach any settings page by its URL - and create and
 * edit forms, tags, templates and the like - because the route let in every agent role and only the menu was cut down.
 *
 * Settings belong to Administrators and Analysts, as the settings menu already had it. `roles` is userRoles.roles from
 * /api/me, which holds the roles a user gets through an Entra group as well as directly: the server maps each of the
 * user's groups to its security role when it builds the claims (AuthConfig.BuildUserRolesAsync). So an agent whose
 * group is an Analyst group has Settings, and an Analyst whose role comes only from a group has it too.
 */
export const hasSettings = (roles: string[]): boolean =>
  roles.includes(ADMINISTRATORS) || roles.includes(ANALYSTS);

const isAgent = (roles: string[]): boolean => roles.includes(AGENTS);

const isKnowledgeRole = (roles: string[]): boolean => roles.includes(KNOWLEDGEAGENT) || roles.includes(KNOWLEDGEREADER);

/**
 * Whether `page` - the path after /settings/, empty for /settings itself - may be opened. Without Settings only
 * Preferences opens, plus the page of the main menu that happens to live under /settings: Users for an agent and the
 * Service Catalog for a knowledge role. A page under another one, such as security/administrators, never matches.
 */
export const canOpenSettingsPage = (roles: string[], page: string): boolean => {
  if (hasSettings(roles))
    return true;

  return page === SETTINGS_PAGES.PREFERENCES
    || (page === SETTINGS_PAGES.USERS && isAgent(roles))
    || (page === SETTINGS_PAGES.KNOWLEDGE && isKnowledgeRole(roles));
};
